import React from 'react'
import PropTypes from 'prop-types'
import { Tab } from '@mui/material_modern'
import { Link } from 'react-router-dom'

const TabLink = ({ to, value, ...props }) => <Tab component={Link} to={to ?? value} value={value} {...props} />

TabLink.propTypes = {
  to: PropTypes.string,
  value: PropTypes.string,
}

TabLink.defaultProps = {
  to: undefined,
  value: '',
}

export default TabLink
